
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import Page from "@/src/components/Page";
import SearchCveShell from "@/src/layouts/SearchCveShell";
const SearchCvePage = ({ q, page }) => (<Page name="Recherche CVE" path="/search-cve/">
        <SearchCveShell q={q} defaultPage={page}/>
    </Page>);
async function getServerSideProps(context) {
    const { query } = context;
    const q = query.q || "";
    const page = query.page ? parseInt(query.page) : 1;
    return {
        props: {
            q, page
        }
    };
}
export default SearchCvePage;

    async function __Next_Translate__getServerSideProps__1a1a753f8d2__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/search-cve',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a753f8d2__ as getServerSideProps }
  